var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.baseData)?_c('div',{style:(_vm.backgroundClass),attrs:{"id":"app1"}},[(_vm.backgroundBlur)?_c('div',{style:(_vm.backgroundImage)}):_vm._e(),_vm._v(" "),(_vm.backgroundBlur)?_c('img',{style:(_vm.foregroundImage),attrs:{"src":_vm.imageUrl}}):_vm._e(),_vm._v(" "),_c('div',{style:(_vm.layerStyles)})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }